<template>
  <van-cell
    :to="'/article/' + item.art_id.toString()"
  >
    <div class="article_item">
      <h3
        class="van-multi-ellipsis--l2"
        :class="{ w66: item.cover.type === 1 }"
      >
        {{ item.title }}
      </h3>
      <van-image
        v-for="(url,i) in item.cover.images"
        :key="url+i"
        lazy-load
        class="w33"
        fit="cover"
        :src="url"
      />
      <div class="info_box">
        <span>{{ item.aut_name }}</span>
        <span>{{ item.comm_count }}评论</span>
        <span>{{ item.pubdate | relTime }}</span>
        <span
          @click.stop="$emit('more-action',item.art_id.toString())"
          v-if="$store.state.user.token && $route.path==='/'"
          class="close"
        >
          <van-icon name="cross"></van-icon>
        </span>
      </div>
    </div>
  </van-cell>
</template>
<script>
export default {
  name: 'ArticleItem',
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
<style scoped lang="less">
// 文章列表
.article_item {
  h3 {
    font-weight: normal;
    line-height: 22px;
    font-size: 16px;
    margin-bottom: 10px;
    &.w66 {
      width: 66%;
      float: left;
      padding-right: 10px;
    }
  }
  .w33 {
    width: 32%;
    height: 75px;
    border-radius: 4px;
    overflow: hidden;
    ~ .w33 {
      margin-left: 2%;
    }
  }
  .info_box {
    color: #999;
    line-height: 22px;
    position: relative;
    font-size: 12px;
    span {
      padding-right: 10px;
      &.close {
        float: right;
        padding-right: 0;
        position: relative;
        top: 2px;
      }
    }
  }
}
</style>
